// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: bk6DX9SSs5T

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSectionSettingsOverlayMenu.module.css"; // plasmic-import: bk6DX9SSs5T/css

import ClosesvgIcon from "./icons/PlasmicIcon__Closesvg"; // plasmic-import: ze_MFlDSdi/icon
import IconsDeleteIcon from "./icons/PlasmicIcon__IconsDelete"; // plasmic-import: svOIRRDbImq/icon

createPlasmicElementProxy;

export type PlasmicSectionSettingsOverlayMenu__VariantMembers = {
  hasAdminPrivilage: "hasAdminPrivilage";
};
export type PlasmicSectionSettingsOverlayMenu__VariantsArgs = {
  hasAdminPrivilage?: SingleBooleanChoiceArg<"hasAdminPrivilage">;
};
type VariantPropType = keyof PlasmicSectionSettingsOverlayMenu__VariantsArgs;
export const PlasmicSectionSettingsOverlayMenu__VariantProps =
  new Array<VariantPropType>("hasAdminPrivilage");

export type PlasmicSectionSettingsOverlayMenu__ArgsType = {};
type ArgPropType = keyof PlasmicSectionSettingsOverlayMenu__ArgsType;
export const PlasmicSectionSettingsOverlayMenu__ArgProps =
  new Array<ArgPropType>();

export type PlasmicSectionSettingsOverlayMenu__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  closeButton?: p.Flex<"button">;
  close?: p.Flex<"svg">;
  deleteSectionButton?: p.Flex<"button">;
  svg?: p.Flex<"svg">;
  group232?: p.Flex<"div">;
  group267?: p.Flex<"div">;
  darkMode?: p.Flex<"div">;
  darkMode2?: p.Flex<"div">;
  group266?: p.Flex<"div">;
  eggshellMode?: p.Flex<"div">;
  divider?: p.Flex<"div">;
  addInterestModalBtn?: p.Flex<"button">;
};

export interface DefaultSectionSettingsOverlayMenuProps {
  hasAdminPrivilage?: SingleBooleanChoiceArg<"hasAdminPrivilage">;
  className?: string;
}

const $$ = {};

function PlasmicSectionSettingsOverlayMenu__RenderFunc(props: {
  variants: PlasmicSectionSettingsOverlayMenu__VariantsArgs;
  args: PlasmicSectionSettingsOverlayMenu__ArgsType;
  overrides: PlasmicSectionSettingsOverlayMenu__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hasAdminPrivilage",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.hasAdminPrivilage
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.roothasAdminPrivilage]: hasVariant(
            $state,
            "hasAdminPrivilage",
            "hasAdminPrivilage"
          )
        }
      )}
    >
      {false ? (
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <button
            data-plasmic-name={"closeButton"}
            data-plasmic-override={overrides.closeButton}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.closeButton
            )}
            onClick={async event => {
              const $steps = {};
            }}
            ref={ref => {
              $refs["closeButton"] = ref;
            }}
          >
            <ClosesvgIcon
              data-plasmic-name={"close"}
              data-plasmic-override={overrides.close}
              className={classNames(projectcss.all, sty.close)}
              role={"img"}
            />
          </button>
        </div>
      ) : null}
      <p.Stack
        as={"button"}
        data-plasmic-name={"deleteSectionButton"}
        data-plasmic-override={overrides.deleteSectionButton}
        hasGap={true}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.deleteSectionButton,
          {
            [sty.deleteSectionButtonhasAdminPrivilage]: hasVariant(
              $state,
              "hasAdminPrivilage",
              "hasAdminPrivilage"
            )
          }
        )}
        ref={ref => {
          $refs["deleteSectionButton"] = ref;
        }}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__cYV,
            {
              [sty.texthasAdminPrivilage__cYVAXm5Q]: hasVariant(
                $state,
                "hasAdminPrivilage",
                "hasAdminPrivilage"
              )
            }
          )}
        >
          {"Delete Section"}
        </div>
        <IconsDeleteIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg)}
          role={"img"}
        />
      </p.Stack>
      <div
        data-plasmic-name={"group232"}
        data-plasmic-override={overrides.group232}
        className={classNames(projectcss.all, sty.group232)}
      >
        <div
          data-plasmic-name={"group267"}
          data-plasmic-override={overrides.group267}
          className={classNames(projectcss.all, sty.group267)}
        >
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img___2C0Zh)}
            displayHeight={"41px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"108px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/7abb8b92ea8089db6f754e04ec856278.svg",
              fullWidth: 108,
              fullHeight: 41,
              aspectRatio: 2.634146
            }}
          />

          <div
            data-plasmic-name={"darkMode"}
            data-plasmic-override={overrides.darkMode}
            className={classNames(projectcss.all, sty.darkMode)}
          >
            <div
              data-plasmic-name={"darkMode2"}
              data-plasmic-override={overrides.darkMode2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.darkMode2
              )}
            >
              {"Dark Mode "}
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"group266"}
          data-plasmic-override={overrides.group266}
          className={classNames(projectcss.all, sty.group266)}
        >
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img__kuOfo)}
            displayHeight={"41px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"105px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/f7260f6ff6dc74b62182f7cadfbe7b98.svg",
              fullWidth: 105,
              fullHeight: 41,
              aspectRatio: 2.560976
            }}
          />

          <div
            data-plasmic-name={"eggshellMode"}
            data-plasmic-override={overrides.eggshellMode}
            className={classNames(projectcss.all, sty.eggshellMode)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__junuW
              )}
            >
              {"Eggshell Mode"}
            </div>
          </div>
        </div>
      </div>
      <div
        data-plasmic-name={"divider"}
        data-plasmic-override={overrides.divider}
        className={classNames(projectcss.all, sty.divider, {
          [sty.dividerhasAdminPrivilage]: hasVariant(
            $state,
            "hasAdminPrivilage",
            "hasAdminPrivilage"
          )
        })}
      />

      <button
        data-plasmic-name={"addInterestModalBtn"}
        data-plasmic-override={overrides.addInterestModalBtn}
        className={classNames(
          projectcss.all,
          projectcss.button,
          projectcss.__wab_text,
          sty.addInterestModalBtn,
          {
            [sty.addInterestModalBtnhasAdminPrivilage]: hasVariant(
              $state,
              "hasAdminPrivilage",
              "hasAdminPrivilage"
            )
          }
        )}
        ref={ref => {
          $refs["addInterestModalBtn"] = ref;
        }}
      >
        {"Add Interest"}
      </button>
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "freeBox",
    "closeButton",
    "close",
    "deleteSectionButton",
    "svg",
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode",
    "divider",
    "addInterestModalBtn"
  ],
  freeBox: ["freeBox", "closeButton", "close"],
  closeButton: ["closeButton", "close"],
  close: ["close"],
  deleteSectionButton: ["deleteSectionButton", "svg"],
  svg: ["svg"],
  group232: [
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode"
  ],
  group267: ["group267", "darkMode", "darkMode2"],
  darkMode: ["darkMode", "darkMode2"],
  darkMode2: ["darkMode2"],
  group266: ["group266", "eggshellMode"],
  eggshellMode: ["eggshellMode"],
  divider: ["divider"],
  addInterestModalBtn: ["addInterestModalBtn"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  closeButton: "button";
  close: "svg";
  deleteSectionButton: "button";
  svg: "svg";
  group232: "div";
  group267: "div";
  darkMode: "div";
  darkMode2: "div";
  group266: "div";
  eggshellMode: "div";
  divider: "div";
  addInterestModalBtn: "button";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSectionSettingsOverlayMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSectionSettingsOverlayMenu__VariantsArgs;
    args?: PlasmicSectionSettingsOverlayMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSectionSettingsOverlayMenu__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSectionSettingsOverlayMenu__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionSettingsOverlayMenu__ArgProps,
          internalVariantPropNames:
            PlasmicSectionSettingsOverlayMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionSettingsOverlayMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSectionSettingsOverlayMenu";
  } else {
    func.displayName = `PlasmicSectionSettingsOverlayMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionSettingsOverlayMenu = Object.assign(
  // Top-level PlasmicSectionSettingsOverlayMenu renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    closeButton: makeNodeComponent("closeButton"),
    close: makeNodeComponent("close"),
    deleteSectionButton: makeNodeComponent("deleteSectionButton"),
    svg: makeNodeComponent("svg"),
    group232: makeNodeComponent("group232"),
    group267: makeNodeComponent("group267"),
    darkMode: makeNodeComponent("darkMode"),
    darkMode2: makeNodeComponent("darkMode2"),
    group266: makeNodeComponent("group266"),
    eggshellMode: makeNodeComponent("eggshellMode"),
    divider: makeNodeComponent("divider"),
    addInterestModalBtn: makeNodeComponent("addInterestModalBtn"),

    // Metadata about props expected for PlasmicSectionSettingsOverlayMenu
    internalVariantProps: PlasmicSectionSettingsOverlayMenu__VariantProps,
    internalArgProps: PlasmicSectionSettingsOverlayMenu__ArgProps
  }
);

export default PlasmicSectionSettingsOverlayMenu;
/* prettier-ignore-end */
